import type { PathType } from './types';
import { getPath } from './types';

export const settingPaths: { [key: string]: PathType } = {
  reportAccount: getPath('/setting/report-account', ['sidebar.setting.index', 'sidebar.setting.reportAccount'])
};
